import { map } from 'lodash';
import core from '@gin-betting/core';
import { Locale } from '@gin-betting/constants';

const {
    constants: { SportType },
} = core;

export const esports = [
    'esports_apex_legends',
    'esports_artifact',
    'esports_basketball',
    'esports_battlegrounds',
    'esports_call_of_duty',
    'esports_counter_strike',
    'esports_crossfire',
    'esports_dota_2',
    'esports_dota_auto_chess',
    'esports_dota_underlords',
    'esports_fifa',
    'esports_formula_1',
    'esports_fortnite',
    'esports_halo',
    'esports_hearthstone',
    'esports_heroes_of_the_storm',
    'esports_ice_hockey',
    'esports_king_of_glory',
    'esports_league_of_legends',
    'esports_mortal_kombat',
    'esports_nba_2k18',
    'esports_overwatch',
    'esports_racing',
    'esports_rainbow_six',
    'esports_rocket_league',
    'esports_smite',
    'esports_soccer_mythical',
    'esports_specials',
    'esports_starcraft',
    'esports_starcraft_1',
    'esports_street_fighter_5',
    'esports_tennis',
    'esports_vainglory',
    'esports_warcraft_3',
    'esports_world_of_tanks',
    'esports_boxing',
    'esports_valorant',
    'esports_volleyball',
    'esports_specials',
    'esports_call_of_duty_warzone',
];

export const classics = [
    'australian_rules',
    'football',
    'basketball',
    'tennis',
    'ice_hockey',
    'volleyball',
    'baseball',
    'beach_volleyball',
    'boxing',
    'futsal',
    'handball',
    'mma',
    'snooker',
    'motorsport',
    'american_football',
    'beach_soccer',
    'badminton',
    'table_tennis',
    'beach_soccer',
    'chess',
    'rugby',
    'rugby_league',
    'formula_1',
    'cycling',
    'darts',
    'water_polo',
    'biathlon',
    'bandy',
    'cross_country',
    'ski_jumping',
    'alpine_skiing',
    'specials',
];

export const SPORT_TYPES = [
    {
        localStorageValue: {
            selectedSportIds: esports,
            sportIds: [...esports, ...classics],
        },
        value: SportType.Esport,
    },
    {
        localStorageValue: {
            selectedSportIds: classics,
            sportIds: [...esports, ...classics],
        },
        value: SportType.Classic,
    },
    {
        localStorageValue: {
            selectedSportIds: [...esports, ...classics],
            sportIds: [...esports, ...classics],
        },
        value: SportType.Mix,
    },
];

export const LANGUAGES = map(Locale, (value, key) => {
    return {
        localStorageValue: { locale: value },
        value,
    };
});

const tokenByLocale = {
    en:
        '8Wsuy7nUhsM7wANUU_FtoRh3BWla4iThJ6kWeb27uze00aNx81cOzLtBQi3wMcsMlumESL0hhtcz3s_gL2SBBPOxu1YYNvy8fvPA9COUsXYhSm5wL5BUoaz9vnbU58l7dLx3ghzryA1NT8FA6ftONQ',
    pt:
        'Uauml3ChZ1HIhYDIDNQiVRFqcPXr2XH71YhuBif4jdZcMTKMiYRoz4426oPHBgRiSpV3_ff5wWJLHBbp-Z89f3ptMcN_aMgm4sRjTnJDzM6_Z1OwaHPbYZJ0awVeEwCYtsUXvA3rao-5QHPI18NAOA',
    zh:
        '3Wtpgw-40tE-u7G-Y5qoqvLneAF9gDCmy8K6f4TIhLMPXyx2xgX3sbQo0_R_-Fy92k19HQn_8lM9XbdM1wstqoxWD7RCz7nf3o7u7mDiXDFh05VjEJalyHLCs__C_S5Xk8kLj6oG4Y6zR3QNL6VgLe3CYgMs_SHAS8wKTPGh8YmKjWg7pQ2rWwXMJl6W5IKAlKZS79oUcbolU7UbTJ4PtZ5D025cKlR9Sqpapz2onA412-mZYHNLfwM49DOxPBaqn-XAMZ0w8Infva1m44_z8vfqZ0K0c6RcDU7-tphLiBP_YlviL19lmPMUbJK1DUZT_WQ84rpVJxInZ7Oyv91vcOZIviVsDG5e1F1j_G_v2VBnfBmmRn2A7Zc0OF7DNg13pnxbaEkS7e9j-SeSP067qqHGv-_lrUR5OIJsSg',
    ru:
        'qp7ladOBNXZ7v6KD7d4YmOhKDu-z6wqWxEQKs-wstkdbjoM7FDqfkOJF8VHoI3ADWiyjfG4JjqW-qluQJFOJjt0TIhnHRxAoH3hR2ijo-u8Eltc4VH-l7Wsa2Wez2TnLtyhf_LI7yl07LiOeY4HiklUrf8rdk5XBF6wxzXNlcRV8dcf5cTp___8nivCaikDOnIZ9vN_cNB-I_jx8CT2nmmY-hZbux40Xvk_LfFx5N9DypmWLgIJLgoBFZIaweJzvpUa2C-4EbNzoRn-7rvjFZEDN9LJHE6MjW3lpnDoYGhUdIwH-Aor3CJ1TkSKDW0sAVC9ey8VNMqU5u_oZm3s9R9bxayQzq0Y7oHPyoAAqBk-N00iMInhGNh_WM5LNtvtIQM132MBXClCTu2Sdbh2qea7l9pKNc-srXQ',
    de:
        'rnp_qi93i6-ZxGnnVfwz7dEh7BA9QmyHQ3lddmaWAtePr0_AX22bOfmHcCKYjW87QTwi3ixFWs0X6jt7zMkzZotHQF9LNXKW1xn6vjOI8i9onOu8YjYmo_zBe04hnaWVJGIhLttoeNbObLsZd0gcyw',
    uk:
        'Q3H_EOaIACIb1xrSK4WcUJiXYy3ppzrCYdoKoA_kPHi3-bgk4PFCfKXqmRvrYvXv-E5KsEKQnzzOWnkHcwMbKuaSIFLDrkQG-tHQ8Sx_LyG5YJpEMUmVsDu66nO7J5fAgu-3HXMuzdQelbpkAvu6bBYzEg',
    pl:
        'JYG-Zi-bh4KEoqA8nCFO5o7ahBR5WqN2Cf_lKDRQlDEA6SEvthErKjs6n1Fl1ACkLxI3eRJ-dCVvxPik_aH87zVq939-MbTc0bqvVpjBlKbZqjMBRJgYAn83jvynYqG7h-b5iNW54EBCd8a4AJmqAg',
    ja:
        'HkMq-RO_U2SVFOxQ-AnsGbp0pw_JzSPCbiyoFPJR7eLoQNM-9QQbwLyt7eur4ZhQLBBIEshUxAliOP6IJlw1-Eiy4I-_MvNHpAeUfLxYvhIfjldym91ljs6d6cv7coGaNQaUBMQhzWl9XRrinBXLoQ',
};

export const FEEDS = [
    // gg.bet
    {
        url: {
            gqlEndpoint: '//betting-public-gql.gin.bet',
            name: 'ggbetv2',
        },
        tokenByLocale,
        token:
            'eQIqaUyqg-XQVMC0WMfwy2po7qbqhJCcFlQCkLlHvd2ZzA6LN_wRZWWpV4sdY9w8IM5hQ1T3CpI5Zqq019OHUYRtbwQbRdZnxu1WXeslYuvxtjXekU-T7cm0lT1IqJ8Z5piazKMhWW4SDKcfvvwLIQ',
    },
    // ggbet.ru
    {
        url: {
            gqlEndpoint: '//b-gql.ggbet.ru',
            name: 'ggbetru',
        },
        tokenByLocale: {},
        token:
            'QWEScYavhW5rrix_2shII_gYjyMQ-oh2BcvW0_zr-6onuCjZSrvkO06vNVJPNP4aI1-f2S1K86wnrbDMjTJxndvGBR8FAK48VLzWi-y7ZHqPhjBfJ_NLOLvSfMtbBJ4nkiPiNZW5rX-4J4IOxkRvu7HxUmo',
    },
    // ggbet.com
    {
        url: {
            gqlEndpoint: '//betting-public-gql.gin.bet',
            name: 'ggbetcom',
        },
        tokenByLocale: {},
        token:
            'xaClWpW-6_C7M_X8odOl1bQKJiPFOVxQzAiZZhiunLdftm_8dFfugErs5pAjbF-BTkX8JhIwlH69dyarATC7RIcv7hKOdvnqh1L6A0TVGaEnpHj64KL3TswPogQyXVBZqZiyvExjrUD8xV9TN9Dlvuc',
    },
    // club-vulkan.com
    {
        url: {
            gqlEndpoint: '//graphql-betting.club-vulkan.com',
            name: 'club-vulkan',
        },
        tokenByLocale: {},
        token:
            'L0o8dRMRucPXfKhwtsjVFBWrejg_XWtN6YecvW2UtBAzDccfKZazWsGJmJJ4uw9-eAr7YPm4KokDtN81-bsbiqKI3ylXRHoIRR5T8agT1KLqbk0WgMpdWKgvvcyYIYclDS_xQTb_IGqLYSRQBsAug3CkREdRdaC96O114iRjMsH8tM8Ex48_9hdYsUCtoJuZ-IeSrobUyX0S3npuFdRN3tUoisigeoMi3TeZ-lnjusPrZAnBC0mJgTkStcC8Zh-IXKia3w',
    },
    // data.bet
    // TODO: (GINFE-1322) Add correct stage name for DATABET to determine prod feed correctly on databet stage.
    {
        url: {
            gqlEndpoint: '//betting-public-gql.gin.bet',
            name: 'databet', // check this name (when DATABET stage will be enabled)
        },
        tokenByLocale: {},
        token:
            'jo73wdevsbTB93ZRtGToQGcSD-D27BdV1R8yA1Elw77X2uQ9kwtFwQTm6biJD1-vEuan3ln2-q43Q4lyoE1ODdklzO1u0aGg29DJtHwU_NmJ2nX4UqJwcC6aQOpVvXG6_sLuK9QhDRBtzFWXSGGCb3U',
    },
    // TODO: (GINFE-1321) These constants need to be moved to vbet to configure correct PROD feed in Helper for both vbet stages
    // vulkanbet.ru
    // {
    //     url: {
    //         gqlEndpoint: '//b-gql.vulkanbet.ru',
    //         name: '//vbet.stage-betting.ginsp.net',
    //     },
    //     token:
    //         'BV40q_3EVpSlMj6ZmFNf6i7gi7WHwue6HDu53ezcCRPGsr32k1WDx75B3jQEIQTg7bmYribg-q9ozESkywzT4JgriwbGdAmvp8WlWlbVV12h7Z86xKkCg09oAURmX759f4KA4osRFV7tlgHANy_T2kFK4D8',
    // },
    // vulkan.bet
    // {
    //     url: {
    //         gqlEndpoint: '//vbet-b-gql.vulkan.bet',
    //         name: '//vbet.stage-betting.ginsp.net',
    //     },
    //     token:
    //         'rpSm8KMaBgfV8I_0dWtrXbwaKoemR1N5mYWU39kyqVZDKbWRGxmPRD3cCeDmUggFV5uCdrHgZLcEWCiCPOENPwMoJgcilnQ4fzQ74Fc3rlAFB8KcJ6_pXWOFmrqXdasieVqjPC_Pc0acdTCeDmvjeMWYIh0',
    // },
] as const;
